import { RefObject, useCallback, useEffect } from "react";

import { TrustpilotSection, useZeroFranchiseTracking } from "./useZeroFranchiseTracking";

interface Props {
  ref: RefObject<HTMLElement | null>;
  section: TrustpilotSection;
}

export const useTrackTrustpilotClick = ({ ref, section }: Props) => {
  const { trackTrustpilot } = useZeroFranchiseTracking();

  const handleTrustpilotClick = useCallback(() => {
    trackTrustpilot(section);
  }, [section, trackTrustpilot]);

  useEffect(() => {
    const handleBlur = () => {
      const iframe = ref.current?.querySelector("iframe");
      if (iframe && document.activeElement === iframe) {
        handleTrustpilotClick();
        setTimeout(() => window.focus(), 0);
      }
    };

    window.addEventListener("blur", handleBlur);
    return () => window.removeEventListener("blur", handleBlur);
  }, [ref, handleTrustpilotClick]);
};
